import { useState } from "react";
import { toast } from "sonner";
import { marketingApi } from "@/lib/marketing";
import { Field, Select, copyToClipboard } from "./shared";

const PLATFORMS = ["google_ads", "chatgpt_ads", "linkedin_ads", "meta_ads", "tiktok_ads"];

export default function PaidAdsPanel({ link }) {
  const [platform, setPlatform] = useState("google_ads");
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const fetchOutput = async (p) => {
    setBusy(true);
    try {
      const res = await marketingApi.getPaidAds(link.link_id, p);
      setResult(res);
    } catch (e) {
      toast.error(e.message || "Could not load Paid Ads output");
    } finally {
      setBusy(false);
    }
  };

  const paramString = result ? new URLSearchParams(result.parameters).toString() : "";

  return (
    <div className="space-y-4" data-testid="paid-ads-panel">
      <Field label="Platform">
        <Select value={platform} onChange={(v) => { setPlatform(v); fetchOutput(v); }} options={PLATFORMS} data-testid="paid-ads-platform-select" />
      </Field>
      <button type="button" onClick={() => fetchOutput(platform)} disabled={busy} data-testid="paid-ads-fetch-button"
        className="bg-ink text-paper py-2 px-4 font-body text-xs uppercase tracking-[0.14em] hover:bg-terracotta transition-colors disabled:opacity-50">
        {busy ? "Loading…" : "Get Final URL"}
      </button>

      {result && (
        <div className="border border-ink/12 p-4 space-y-3 text-sm" data-testid="paid-ads-result">
          <p className="font-body text-terracotta text-xs uppercase tracking-[0.14em]">Never the branded redirect — always the direct destination</p>
          <div>
            <p className="font-body text-xs uppercase tracking-wide text-ink-soft">Final URL</p>
            <p className="font-body text-ink break-all" data-testid="paid-ads-final-url">{result.final_url}</p>
            <button type="button" onClick={() => copyToClipboard(result.final_url, "Final URL")} data-testid="paid-ads-copy-final-url" className="font-body text-xs text-terracotta hover:underline">Copy Final URL</button>
          </div>
          <div>
            <p className="font-body text-xs uppercase tracking-wide text-ink-soft">Parameters</p>
            <p className="font-body text-ink-soft break-all text-xs" data-testid="paid-ads-parameters">{paramString}</p>
            <button type="button" onClick={() => copyToClipboard(paramString, "Parameters")} data-testid="paid-ads-copy-parameters" className="font-body text-xs text-terracotta hover:underline">Copy Parameters</button>
          </div>
          <div>
            <p className="font-body text-xs uppercase tracking-wide text-ink-soft">Tracking template / suffix</p>
            <p className="font-body text-ink-soft break-all text-xs" data-testid="paid-ads-suffix">{result.tracking_template_suffix}</p>
            <button type="button" onClick={() => copyToClipboard(result.tracking_template_suffix, "Tracking template")} data-testid="paid-ads-copy-suffix" className="font-body text-xs text-terracotta hover:underline">Copy Tracking Template</button>
          </div>
          <div>
            <p className="font-body text-xs uppercase tracking-wide text-ink-soft">Native click ID</p>
            <p className="font-body text-ink text-xs" data-testid="paid-ads-click-id">{result.native_click_id_param}{result.native_click_id_macro ? ` (macro: ${result.native_click_id_macro})` : " (auto-appended by platform)"}</p>
          </div>
        </div>
      )}
    </div>
  );
}
